import React from 'react';
import AppVars from '../../AppVars.js'
import ActivateSuccessView from '../Views/TO/Activate/ActivateSuccessView';

const appVars = AppVars.getInstance();


class ActivateSuccess extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            redirectURI: this.props.redirectURI
        }
    }


    render() {
        return(
            <ActivateSuccessView
            login = {this.login}
            redirectURI = {this.state.redirectURI}
            />
        )
    }

    login() {
        //const dest = this.parseRedirectFromURL() == null ? "/" : this.parseRedirectFromURL();
        window.location.href = this.props.redirectURI;
    }


    parseRedirectFromURL() {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const redirect_uri = params.get('redirect_uri');
        return redirect_uri
    }

}

export default ActivateSuccess